import { Component, OnInit } from '@angular/core';
import { ClientService } from '../services/client.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css']
})
export class ClientDetailsComponent implements OnInit {

  loadingClient: boolean = false;
  client: ClientDetails | null = null;
  agents: ClientAgentWithName[] = [];
  agreements: Agreement[] = [];
  // editing
  clientEditData: ClientEditDetails | null = null;
  disableModalSaveButton: boolean = false;
  editClientDetailsIsActive: boolean = false;
  isSavingModal: boolean = false;
  // modal extras
  modalErrorMessage: string = "";
  modalSuccessMessage: string = "";

  constructor(private clientService: ClientService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const client_id = params.get('client_id');
      if (client_id) {
        this.loadClientDetails(parseInt(client_id));
      }
    });
  }

  loadClientDetails(client_id: number) {
    this.loadingClient = true;
    this.client = null;
    this.clientService.getClientDetails(client_id).subscribe({
      next: (res: ClientDetailsResponse) => {
        this.client = res.data;
        this.agents = res.data.agents;
        this.loadingClient = false;
      },
      error: (err) => {
        console.error(err);
        this.loadingClient = false;
      }
    });
  }

  showClientDetailsEditModal() {
    this.editClientDetailsIsActive = true;
    this.clientEditData = {
      client_name: this.client?.client_name || '',
      company_name: this.client?.company_name || '',
      billing_frequency: this.client?.billing_frequency || 'weekly'
    } as ClientEditDetails;
  }

  closeModal(){
    this.editClientDetailsIsActive = false;
    this.clientEditData = null;
    this.disableModalSaveButton = false;
    this.isSavingModal = false;
  }

  updateClientDetails(){
    this.isSavingModal = true;
    this.disableModalSaveButton = true;

    this.clientService.updateClientDetails(this.client.client_id, this.clientEditData).subscribe({
      next: (res: ClientDetailsResponse) => {
        this.client = res.data;
        this.isSavingModal = false;
        this.disableModalSaveButton = false;
        this.editClientDetailsIsActive = false;
        this.clientEditData = null;
      },
      error: (err) => {
        console.error("Update Client Error:\n",err);
        this.isSavingModal = false;
        this.disableModalSaveButton = false;
        this.modalErrorMessage = err.error.detail || "An error occurred while saving client details.";
      }
    });

  }

  getAgreementChangesKeys(agreementChanges: { [date: string]: AgreementChange } | undefined): string[] {
    if (!agreementChanges) return [];
    return Object.keys(agreementChanges).sort((a, b) => new Date(b).getTime() - new Date(a).getTime());
  }

  toggleAgreement(agreement: Agreement, index: number) {
    agreement.expanded = !agreement.expanded;
    // scroll down to bottom if expanded
    if (agreement.expanded) {
      setTimeout(() => {
        const agreementElement = document.querySelectorAll('.collapsible-agreement')[index];
        if (agreementElement) {
          agreementElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      }, 100);
    }
  }

}
